import { plansReducer, plansWatcher } from './plans';
import { salesChannelsReducer, salesChannelsWatcher } from './sales-channels';
import { planSettingsReducer, settingsWatcher } from './settings';
import {
  planBuilderApiClientsReducer,
  planBuilderApiClientWatcher,
} from './api-clients';
import {
  planCanSellTotalsThresholdReducer,
  planCanSellTotalsThresholdWatcher,
} from './plan-can-sell-totals-threshold';
import { canEditReducers, canEditWatchers } from './can-edit-settings';
import {
  planUpgradePathsReducer,
  planUpgradePathsWatcher,
} from './plan-upgrade-paths';
import { repDetailsReducer, repDetailsWatcher } from './rep-details';
import { areaPlansReducer, areaPlansWatcher } from './area-plans';
import { groupPlansReducer, groupPlansWatcher } from './group-plans';

export const planBuilderReducers = {
  ...plansReducer,
  ...salesChannelsReducer,
  ...planSettingsReducer,
  ...planBuilderApiClientsReducer,
  ...planCanSellTotalsThresholdReducer,
  ...planUpgradePathsReducer,
  ...repDetailsReducer,
  ...areaPlansReducer,
  ...canEditReducers,
  ...groupPlansReducer,
};

export const planBuilderSagas = () => ([
  plansWatcher(),
  salesChannelsWatcher(),
  settingsWatcher(),
  planBuilderApiClientWatcher(),
  planCanSellTotalsThresholdWatcher(),
  planUpgradePathsWatcher(),
  repDetailsWatcher(),
  areaPlansWatcher(),
  groupPlansWatcher(),
  ...canEditWatchers(),
]);
